/**
 * NavbarPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from 'react';
import { Link } from 'react-router-dom';

import { usePostHog } from '@posthog/react';
import { Content } from './styledComponents';

export default function Navbar() {
  const posthog = usePostHog();
  return (
    <Content>
      <Link
        to="/"
        onClick={() => {
          posthog.capture('salir_logo');
        }}
      >
        <img className="logo" src="/images/logo.png" alt="Logo Conmigo Vales" />
      </Link>
    </Content>
  );
}
